import { Injectable } from '@nestjs/common';
import { OnEvent } from '@nestjs/event-emitter';
import { EmailNotificationEvent } from '../models/emai-notification.event';
import { NotificationDataAccessService } from '@ip6m/server/data-access-notification';
import { Loggable } from '@ip6m/server/shared';
import { Notification } from '@ip6m/server/data-access-notification';

@Injectable()
export class NotificationService {
  constructor(
    private notificationDataAccessService: NotificationDataAccessService
  ) {}

  @Loggable
  sendMessage(notification: Notification) {
    this.notificationDataAccessService.sendMessage(notification);
  }

  @OnEvent('notification.email')
  handleEmailNotificationEvent(event: EmailNotificationEvent) {
    this.notificationDataAccessService.sendMessage(event);
  }
}
